/** Simple FAQs aligned with WebNetram schema tables available to the SQL agent. */
export interface SqlFaqCategory {
  id: string;
  title: string;
  questions: string[];
}

export const SQL_CHATBOT_FAQS: string[] = [
  "Show today's OPD visits with patient name and doctor",
  'How many OPD visits happened today?',
  'Show patients registered last week',
  'How many patients registered today?',
  'How many bills were created this month?',
  'What is the total billing amount for this month?',
  'List top 10 services by billing amount',
  'Show today\'s bills with patient name and net amount',
  'List receipts collected today',
  'Show branch-wise OPD visit count for today',
  'List top 10 doctors by number of OPD visits this month',
  'Show IPD registrations for this month',
  'List active services from service master',
  'Show OPD visits from yesterday with visit date and time',
  'How many bills were created today?',
];
